// extracted by mini-css-extract-plugin
export var adjacentSlide = "_sv-9";
export var arrowButtonContainer = "_sv-5";
export var arrowButtonIcon = "_sv-6";
export var carouselArrowButton = "_sv-2";
export var carouselElementContainer = "_sv-1";
export var currentSlide = "_sv-8";
export var left = "_sv-3";
export var otherSlide = "_sv-a";
export var productCarouselContainer = "_sv-0";
export var right = "_sv-4";
export var sliderOverflow = "_sv-7";